import React, {memo, useState, useEffect} from "react";
import Api from '../../interface/api/site';
import {SiteInfo} from "../../interface/model/site";
import {BlueButton} from "../../component/button";

interface SiteMap {
    modal:boolean,
}

function SelectBox({rows, setRow}) {
    return (
        <select className="nv_select_box"
                onChange={(e) => setRow(rows[e.target.selectedIndex-1])} >
            <option selected={true} disabled={true}>선택</option>
            {
                rows.map((row, index) => (
                    <option key={`findSiteSelectBoxKey-${index}`}
                            value={row.seq}
                    >{row.name}
                    </option>
                ))
            }
        </select>
    )
}

function FindSiteComponent({siteInfo, selectedHandler}) {

    const [ sites1, setSites1 ] = useState<Array<SiteInfo>>([]);
    const [ sites2, setSites2 ] = useState<Array<SiteInfo>>([]);

    const [ selectedDepth, setSelectedDepth ] = useState<string>();
    const [ selectedDepth1, setSelectedDepth1 ] = useState<string>();
    const [ selectedDepth2, setSelectedDepth2 ] = useState<string>();
    const [ siteMap, setSiteMap ] = useState<SiteMap>({modal:false});

    function closeModalHandler() {
        setSiteMap({modal:false})
    }

    function openModalHandler() {
        setSiteMap({modal:true})
    }

    function nextOption(row) {
        switch (row.depth) {
            case 2:
                if(row.childrenSiteInfos.length == 0) {
                    selectedHandler(`${selectedDepth},${selectedDepth1},${row.name}`);
                } else {
                    setSites2(row.childrenSiteInfos);
                }
                setSelectedDepth2(row.name);
                break;
            case 3:
                selectedHandler(`${selectedDepth},${selectedDepth1},${selectedDepth2},${row.name}`);
                break;
        }
    }

    useEffect(() => {
        //let siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
        setSelectedDepth(siteInfo.parentSiteInfo.name);
        setSelectedDepth1(siteInfo.name);
        setSites1(siteInfo.childrenSiteInfos);
        // Api.siteInfoListBySeq(4).then(res => {
        //     setSelectedDepth(res.data.parentSiteInfo.name);
        //     setSelectedDepth1(res.data.name);
        //     setSites1(res.data.childrenSiteInfos);
        // });
    }, []);

    return (
        <>
            <div>
                <select className="nv_select_box">
                    <option>{`${selectedDepth}`}</option>
                </select>
                <select className="nv_select_box" >
                    <option>{`${selectedDepth1}`}</option>
                </select>
                <SelectBox rows={sites1} setRow={nextOption}/>
                <SelectBox rows={sites2} setRow={nextOption}/>
            </div>
        </>
    )
}

export default memo(FindSiteComponent);